class ManageMenu{

    constructor() {
        this.navbarToggle = document.getElementById("navbar-toggle");
        this.navbarStart = this.navbarToggle.querySelector(".navbar-start");
        this.itemsMenu = this.navbarStart.querySelectorAll("a");

        this.onlyDisplayPartnersItem();
    }

    onlyDisplayPartnersItem() {
        for (let i = 0; i < this.itemsMenu.length; i++) {
            if(!this.itemsMenu[i].classList.contains("red")){
                this.itemsMenu[i].textContent = "";
            }
            this.itemsMenu[i].addEventListener("click", (e) => {
               e.preventDefault();
            });
        }
    }
}